import './App.css';
import Quiz from './components/Quiz';
import DarkMode from './components/Darkmode';
import logo from './pchs-logo.svg';

function App() {
  return (
    <div className="App">
      <div className='flex-end'>
        <DarkMode />
      </div>
      <Quiz />
      <footer className="footer">
          <p className="text-muted">
            Copyright &copy; {new Date().getFullYear()}
            <br/>
            <img src={logo} alt='Pacific College of Health and Science' className='logo' />
          </p>
      </footer>
    </div>
  );
}

export default App;
